export const NAVIGATE = {
	// --- AUTH --- //
	HOME: '/',
	CLIENT_DASHBOARD: '/client/home',
	SIGN_IN: '/auth/sign-in',
	SIGN_UP: '/auth/sign-up',
	FORGOT_PASSWORD: '/auth/forgot-password',

	// --- BRANDS --- //
	BRANDS: '/client/dashboard',
	BRANDS_DETAIL: '/client/dashboard/detail',

	// --- EDUCATION --- //
	EDUCATION_CENTER: '/client/education/center',
	REWARDS: '/client/education/bumbei-rewards',

	// --- PROFILE --- //
	PROFILE_OVERVIEW: '/client/profile/overview',
	ACTIVITY: '/client/profile/activity',
	WALLET: '/client/profile/wallet',

	// --- ADMIN --- //
	ADMIN_DASHBOARD: '/admin/dashboard',
} as const;
